import mixpanel from "mixpanel-browser";

mixpanel.init(process.env.REACT_APP_MIX_PANEL_TOKEN as string, { ignore_dnt: true });

const recordEvent = (eventName: string, properties: any) => {
  mixpanel.track(eventName, properties);
};

export default recordEvent;
